import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { Typography } from '@stories/Elements/Typography/Typography.styles';
import styled from 'styled-components';

const Card = styled.div`
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  flex: 0 0 auto;
  padding: 15px 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media ${from(Device.TabletLarge)} {
    padding: 30px 40px;
  }

  svg {
    width: 400px;
    height: 140px;
    color: ${brand.red.base};

    max-width: 100%;
  }
`;

const Body = styled.div`
  flex: 1 0 auto;
  padding: 25px 20px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  text-align: center;

  @media ${from(Device.TabletLarge)} {
    padding: 35px 40px;
  }
`;

const Title = styled(Typography.H3)`
  color: ${brand.white};
  ${fonts.helvetica['97-black-condensed']};
`;

const Description = styled(Typography.P)`
  color: ${brand.white};
  ${fonts.helvetica['55-roman']};
`;

const SubTitle = styled.h4`
  ${Typography.H5Style}
  color: ${brand.white};
  ${fonts.helvetica['87-heavy-condensed']};
`;

const AccessoriesText = styled(Typography.P)`
  color: ${brand.white};
  ${fonts.helvetica['55-roman']};
  border-top: 1px solid ${brand.grey[80]};
  padding-top: 10px;
`;

export const PerfectMatchCardStyles = {
  Card,
  Header,
  Body,
  Title,
  Description,
  SubTitle,
  AccessoriesText,
};
